var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef, useRef } from 'react';
import { Menu } from '@base-ui/react/menu';
import { useFloatingPortalNode } from '@floating-ui/react';
import { PORTAL_ID } from 'modules/PortalProvider';
import { ScrollArea } from 'modules/ScrollArea';
import { MenuProvider } from './MenuProvider';
import { StyledContent, StyledPositioner } from './styled';
export const MenuRoot = forwardRef((props, ref) => {
    const { target, children, open, className, sideOffset = 4, defaultOpen = false, side = 'bottom', align = 'start', useTriggerWidth = false, onClose } = props, widthProps = __rest(props, ["target", "children", "open", "className", "sideOffset", "defaultOpen", "side", "align", "useTriggerWidth", "onClose"]);
    const controlled = open !== undefined;
    const portalNode = useFloatingPortalNode({ id: PORTAL_ID });
    const actionsRef = useRef(null);
    const close = () => { var _a; return (_a = actionsRef.current) === null || _a === void 0 ? void 0 : _a.close(); };
    const handleOnOpenChange = (newOpen) => {
        if (!newOpen) {
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }
    };
    return (<Menu.Root open={open} defaultOpen={defaultOpen} onOpenChange={handleOnOpenChange} actionsRef={actionsRef}>
      <Menu.Trigger ref={ref} render={target}/>
      <Menu.Portal container={portalNode}>
        <StyledPositioner sideOffset={sideOffset} side={side} align={align} collisionPadding={8}>
          <StyledContent {...widthProps} $useTriggerWidth={useTriggerWidth} className={className}>
            <ScrollArea>
              <MenuProvider controlled={controlled} close={close}>
                {children}
              </MenuProvider>
            </ScrollArea>
          </StyledContent>
        </StyledPositioner>
      </Menu.Portal>
    </Menu.Root>);
});
